import { getImageSize } from '@/libs/utils/docxUtils'
import { AlignmentType, ImageRun, Paragraph, TextRun, PageBreak } from 'docx'

const Chapter4Sub9Page = async ({ barChart2Img }) => {
  try {
    if (!barChart2Img) {
      throw new Error('No image data provided for donut chart.')
    }
    const { width, height } = await getImageSize({ image: barChart2Img, width: 550 })

    return [
      new Paragraph({ children: [new PageBreak()] }),
      new Paragraph(''),
      new Paragraph({
        style: 'textParagraph',
        children: [
          new TextRun({
            text: '\t',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '依照',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '歷年人數',
            bold: true,
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '統計之',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '之人數比例橫條圖：',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
        ],
      }),
      new Paragraph(''),
      new Paragraph(''),
      new Paragraph({
        alignment: AlignmentType.CENTER,
        // spacing: { before: pixelToDxa(30), after: pixelToDxa(30) },
        children: [
          new ImageRun({
            data: barChart2Img,
            transformation: {
              width,
              height,
            },
          }),
        ],
      }),
    ]
  } catch (error) {
    console.error('Error generating Word document:', error)
    return []
  }
}

export default Chapter4Sub9Page
